import { render, staticRenderFns } from "./TableTabs.vue?vue&type=template&id=06e2fb91&scoped=true&"
import script from "./TableTabs.vue?vue&type=script&lang=ts&"
export * from "./TableTabs.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06e2fb91",
  null
  
)

export default component.exports